import { Grid } from "@mui/material";
import BuildingList from "./BuildingList";
import ButtonAddBuilding from "./BuildingAdd";

const BuildingTable = () => {
  return (
    <Grid container>
      <BuildingList />
      <Grid item xs={12} my={4}>
        <ButtonAddBuilding />
      </Grid>
    </Grid>
  );
};

export default BuildingTable;
